import './App.css';
// import { React } from 'react';
import { React, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
// import { AnimatePresence } from 'framer-motion';
import Particles from './scenes/Particles';
import Main from './pages/Main';
import Projects from './pages/Projects';
import Info from './pages/Info';
import About from './pages/About';

import Page from './components/Page';
import Fetch from './components/Fetch.js';
import {FetchProvider} from './components/FetchContext';
import { AnimatePresence, motion } from 'framer-motion';
import { Info as InfoIcon, Folder, User, ArrowLeft, ArrowUp } from 'lucide-react';

import { Helmet } from "react-helmet-async";

const MetaTags = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Pyotr Lye",
    "url": "https://pyotr.xyz/",
    "sameAs": [
      "https://github.com/owoleya",
      "https://www.linkedin.com/in/pyotr-lye-91982b89/",
      "https://www.behance.net/pyotrlye",
      "https://instagram.com/pyotrxyz"
    ],
    "jobTitle": "Creative Developer & Designer",
    "worksFor": {
      "@type": "Organization",
      "name": "Freelance"
    },
    "description": "Pyotr Lye is a creative developer and designer specializing in modern web experiences, animations, and digital branding."
  };
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <link rel="icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#131313" />
      <meta name="description" content="Pyotr Lye is a creative developer and designer specializing in modern web experiences, animations, and digital branding. Born in 2001 at Kuala Lumpur, Malaysia, I believe that web design is a tool for me to give more life to the ideas I have and make designs feel more expressive."  />

      {/* Open Graph / Social Media Meta Tags */}
      <meta property="og:title" content="Pyotr Lye | Creative Developer & Designer" />
      <meta property="og:description" content="Pyotr Lye is a creative developer and designer specializing in modern web experiences, animations, and digital branding." />
      <meta property="og:url" content="https://pyotr.xyz/" />
      <meta property="og:type" content="website" />

      {/* Icons */}
      <link rel="apple-touch-icon" href={`${process.env.PUBLIC_URL}/logo192.png`} />

      <script type="application/ld+json">
      {JSON.stringify(structuredData)}
      </script>
      
      {/* Fonts and Styles */}
      <link rel="stylesheet" href="fonts.css" />

      {/* Manifest */}
      <link rel="manifest" href={`${process.env.PUBLIC_URL}/manifest.json`} />

      {/* SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="Pyotr Lye, Pyotr, pyotr.xyz, pyotrxyz, pyotrdotxyz, owoleya, oamleya, Pyotr Lye Chuan Hoong, portfolio, web developer, frontend, designer, UI/UX, JavaScript, React" />
      
      {/* Performance */}
      {/* <link rel="preload" as="image" href="http://assets.iceable.com/img/noise-transparent.png" /> */}

      {/* Canonical URL */}
      <link rel="canonical" href="https://pyotr.xyz" />

      <title>Pyotr Lye | Creative Developer & Designer</title>
    </Helmet>
  );
};

function AnimatedRoutes() {

  const location = useLocation();
  const isIndexPage = location.pathname === '/';

  const [data, setData] = useState(null)
  const [loaded, setImageLoading] = useState(false)
  const [targetProgress, setTargetProgress] = useState(0)
  const [displayProgress, setDisplayProgress] = useState(0)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await Fetch();
        setData(fetchedData); // Set the fetched data
      } catch (error) {
        console.error('Error fetching data:', error);
        setTargetProgress(100);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!data) return;

    const itemsWithThumbnails = data.filter((item) => item.thumbnail);
    if (itemsWithThumbnails.length === 0) {
      setTargetProgress(100);
      return;
    }

    let loadedCount = 0;
    const total = itemsWithThumbnails.length;

    const updateProgress = () => {
      loadedCount++;
      const currentProgress = Math.round((loadedCount / total) * 100);
      setTargetProgress(currentProgress);
    };

    itemsWithThumbnails.forEach((item) => {
      const img = new Image();
      img.src = item.thumbnail;
      img.onload = updateProgress;
      img.onerror = updateProgress;
    });
  }, [data]);

  useEffect(() => {
    if (displayProgress < targetProgress || (data && targetProgress === 100 && displayProgress < 100)) {
      const timer = setTimeout(() => {
        setDisplayProgress((prev) => prev + 1);
      }, 12);
      return () => clearTimeout(timer);
    } else if (targetProgress >= 100 && displayProgress >= 100 && !loaded) {
      const timer = setTimeout(() => {
        setImageLoading(true);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [displayProgress, targetProgress, data, loaded]);

  

  return (
  // !loading ?
  // (
    <>
    {/* <div className='fixed w-screen h-screen -z-20'>  , transform:`translateY(${pos(location.pathname)}%) scale(${(isIndexPage ? '1' : '1.3')})`*/} 
      <div className='absolute w-full h-full transition-all ease-out duration-1000' style={{filter:`blur(${(loaded ? (isIndexPage ? '0.5' : '10') : '5')}px)`,scale:(loaded ? '1' : '1.1')}}>
        <Particles color='white' newposition={(isIndexPage ? '0' : '-20')}/>
      </div>
    {/* </div> */}

    {/* <div className='fixed bg-black/50 backdrop-blur-sm h-screen w-screen transition-opacity duration-[2000ms]' style={{opacity:(data ? '0' : '1'),pointerEvents:(data ? 'none' : 'auto')}}/> */}

    <FetchProvider fetch={data}>
        <AnimatePresence mode='wait'>
            <motion.div
              key={loaded}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, }}
              transition={{ duration: 0.3 }}
            >
              {loaded ?
              <>
                <Nav />
                <AnimatePresence mode="wait">
                  <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<Page><Main /></Page>} />
                    <Route path="/about" element={
                      <Page>
                        <ContentContainer>
                          <About />
                        </ContentContainer>
                      </Page>
                    } />
                    <Route path="/*" element={
                      <Page>
                        <div className="flex  w-full h-screen text-white justify-end items-center p-12">
                          <svg fill="none" viewBox="0 0 24 24" strokeLinejoin="1.5" stroke="currentColor" className='size-8 mr-4'>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                          </svg>
                          <Link to='/' className='text-2xl  lg:text-5xl origin-right font-thin italic tracking-normal hover:tracking-wide opacity-100 hover:opacity-50 transition-all'>
                            Page not found. Click here to return
                          </Link>
                        </div>
                      </Page>
                    } />
                    <Route path="/projects" element={
                      <Page>
                        <ContentContainer>
                          <Projects />
                        </ContentContainer>
                      </Page>
                    } />
                    <Route path="/info" element={
                      <Page>
                        <ContentContainer>
                          <Info />
                        </ContentContainer>
                      </Page>
                    } />
                    {/* <Route path="/about" element={<About />} /> */}
                    {/* <Route path="/info" element={<Info />} /> */}
                  </Routes>
                </AnimatePresence>
              </>
              : 
              <div className='fixed inset-0 flex items-center justify-center text-white z-50 select-none'>
                <motion.span
                  key={displayProgress}
                  transition={{ duration: 0.02 }}
                  className='text-xl font-bold tabular-nums'
                >
                  {displayProgress}%
                </motion.span>
              </div>
              }
            </motion.div>
        </AnimatePresence>
      </FetchProvider>

    </>
  )
  // :
  // (<></>));
}

function ContentContainer ({children}){
  return(
    <div className='w-screen h-screen flex items-end justify-end'>
      <div className='p-4 lg:p-16 w-full h-[calc(100vh-96px)] lg:h-full lg:w-[calc(100vw-192px)]'>
        {children}
      </div>
    </div>
  )
}

function Nav() {
  const location = useLocation();
  
  const pages = [
    {
      name: "info",
      icon: <InfoIcon size={20} strokeWidth={1.5} />
    },
    {
      name: "projects",
      icon: <Folder size={20} strokeWidth={1.5} />
    },
    {
      name: "about",
      icon: <User size={20} strokeWidth={1.5} />
    },
  ]
  
  const isIndexPage = !pages.map(page => `/${page.name}`).includes(location.pathname);
  // const pos = (value) => ({
  //   '/about': "0",
  //   '/projects': "50",
  //   '/info': "00",
  // }[value] || "0")
  
  return(
    <>
      <div className='w-full fixed flex justify-center lg:hidden px-2 py-8 z-[999]' style={{transform: `translateY(${(isIndexPage ? '-15' : '0')}rem)`, transition: 'transform 1.5s ease-in-out'}}>
        <div className='w-full grid grid-cols-5 items-center justify-center text-sm gap-x-2 text-white font-semibold tracking-widest font-main relative' >
          
            <Link to='/' aria-label="Home" className='size-9 rounded-full bg-white bg-opacity-0 hover:bg-opacity-30 text-white flex items-center justify-center transition-all cursor-pointer'>
                <ArrowLeft size={20} strokeWidth={1.5} />
            </Link>
            {pages.toReversed().map((item, index) => (
              <Link aria-label={item.name} className={`capitalize relative col-span-1 text-center py-2 flex items-center justify-center rounded-full bg-white ${location.pathname === `/${item.name}` ? '!bg-opacity-100 text-black' : 'hover:bg-opacity-30 bg-opacity-0'}  cursor-pointer transition-all duration-300 relative z-10`} key={index} to={`/${item.name}`}>
                  {/* <span className='absolute group-hover:opacity-100 opacity-0 transition-opacity mx-1'>•</span> */}
                  <span>{item.icon}</span> 
              </Link>
            ))}
        </div>
      </div>
      <div className='absolute w-[95vh] bottom-0 left-20 hidden lg:flex items-center justify-between px-12 z-[999] origin-left' style={{transform: `rotate(-90deg)  translateY(${(isIndexPage ? '-15' : '0')}rem)`, transition: 'transform 1.5s ease-in-out'}}>
        <span className='text-white/50 text-lg font-light tracking-widest font-main whitespace-nowrap'>© {(new Date().getFullYear())}</span> 

        <div className='h-[1px] bg-white/10 grow mx-8' />

        <div className='grid grid-cols-3 items-center justify-center gap-x-4 text-white text-lg font-semibold tracking-widest font-main relative'>
          {pages.map((item, index) => (
            <Link className={`capitalize relative col-span-1 text-center py-1 w-32 flex items-center justify-center rounded-full bg-white ${location.pathname === `/${item.name}` ? '!bg-opacity-0' : 'hover:bg-opacity-30 bg-opacity-0'}  cursor-pointer transition-all duration-300 relative z-10`} key={index} to={`/${item.name}`}>
                {/* <span className='absolute group-hover:opacity-100 opacity-0 transition-opacity mx-1'>•</span> */}
                <span>{item.name}</span> 
            </Link>
          ))}
          <div className='absolute rounded-full bg-black h-8 w-32 z-0 transition-all duration-500 ease-out' style={{
            left:`${({ '/about': "100", '/projects': "50", '/info': "0", }[location.pathname] || "100")}%`,
            transform:`translateX(${({ '/about': "-100", '/projects': "-50", '/info': "0", }[location.pathname] || "-100")}%)`,
            transitionDelay:`${(isIndexPage ? '1000ms' : '0s')}`
            // opacity:`${(isIndexPage ? '0' : '1')}`
            }}/> 
          <div className='absolute rounded-full backdrop-invert h-8 w-32 z-20 transition-all duration-500 ease-out' style={{
            left:`${({ '/about': "100", '/projects': "50", '/info': "0", }[location.pathname] || "100")}%`,
            transform:`translateX(${({ '/about': "-100", '/projects': "-50", '/info': "0", }[location.pathname] || "-100")}%)`,
            transitionDelay:`${(isIndexPage ? '1000ms' : '0s')}`
            }} />
        </div>
        {/* <div className='grid grid-cols-3 items-center justify-center gap-x-4 text-white text-lg font-semibold tracking-widest font-main'>
          {pages.map((item, index) => (
            <Link className={`capitalize col-span-1 text-center py-1 px-6 rounded-full bg-white ${location.pathname === `/${item}` ? '!bg-opacity-100' : 'bg-opacity-0'} hover:bg-opacity-30 cursor-pointer transition-all duration-300 relative`} key={index} to={`/${item}`}>
                <span className={`${location.pathname === `/${item}` ? '!text-black' : ''} transition-all`}>{item}</span> 
            </Link>
          ))}
        </div> */}

        <div className='h-[1px] bg-white/10 grow mx-8' />

        <Link to='/' aria-label="Home" className='size-9 rounded-full bg-white bg-opacity-0 hover:bg-opacity-30 text-white flex items-center justify-center transition-all cursor-pointer'>
            <ArrowUp size={20} strokeWidth={1.5} />
        </Link>
        {/* <div className='size-8 rounded-full outline-4 outline-white/30 bg-white flex items-center justify-center'>
          <svg className='absolute rotate-90' style={{display:'none'}} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
          </svg>
          <svg className='absolute' width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
          </svg>
        </div> */}
      </div>
    </>
  )
}

function App() {
  useEffect(() => {
    if (window.location.pathname === '/commission') {
      window.location.href = 'https://forms.gle/WDhTvcBrP3o8tzqUA'; // Use navigate('/new-path') for internal navigation
    }
  }, []);

  return (
    <>
      <MetaTags />
      <BrowserRouter>
        <div
          id='background' className='w-screen h-screen overflow-hidden'
        > 
          <AnimatedRoutes />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;

